package com.patronat.top.client.presentation.splash

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.AppIcons

@Composable
fun ClientSplashScreen(
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(SplashBackground),
        contentAlignment = Alignment.Center
    ) {
        Image(
            painter = AppIcons.LogoTransparent,
            contentDescription = null,
            contentScale = ContentScale.Fit,
            modifier = Modifier.size(178.dp)
        )
    }
}

private val SplashBackground = Brush.verticalGradient(
    colors = listOf(
        Color(0xFF383B49),
        Color(0xFF171925),
        Color(0xFF05060A)
    )
)
